import React from 'react';
import Image from './Image';
import styled from 'styled-components';

export const CarrierLogoStyled = styled.img`
  max-width: 100%;
  max-height: 25px;
  padding-right: ${props => props.theme.spacing.small};
`;

export default function CarrierLogo(props) {
  const { src, alt, loading } = props;

  return (
    <Image>
      <CarrierLogoStyled src={src} alt={alt} {...(!!loading && { loading })} />
    </Image>
  );
}
